import { create } from 'zustand';

export const useCalendarStore = create((set, get) => ({
  // Current calendar data
  currentCalendar: null,
  calendars: [],
  
  // UI state
  selectedItem: null,
  isLoading: false,
  error: null,

  // Actions
  setCurrentCalendar: (calendar) => set({ currentCalendar: calendar }),
  
  setCalendars: (calendars) => set({ calendars }),
  
  addCalendar: (calendar) => set((state) => ({
    calendars: [calendar, ...state.calendars]
  })),
  
  removeCalendar: (id) => set((state) => ({
    calendars: state.calendars.filter(c => c.id !== id),
    currentCalendar: state.currentCalendar?.id === id ? null : state.currentCalendar
  })),
  
  // Alias for compatibility
  selectItem: (item) => set({ selectedItem: item }),
  setSelectedItem: (item) => set({ selectedItem: item }),
  
  clearSelectedItem: () => set({ selectedItem: null }),
  
  updateItem: (itemId, updates) => set((state) => {
    if (!state.currentCalendar) return state;
    
    const updatedItems = state.currentCalendar.items.map(item =>
      item.id === itemId ? { ...item, ...updates } : item
    );
    
    // Update calendar grouped by day
    const calendar = {};
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    days.forEach(day => {
      calendar[day] = updatedItems.filter(i => i.day === day);
    });
    
    return {
      currentCalendar: {
        ...state.currentCalendar,
        items: updatedItems,
        calendar
      },
      selectedItem: state.selectedItem?.id === itemId 
        ? { ...state.selectedItem, ...updates }
        : state.selectedItem
    };
  }),
  
  setLoading: (isLoading) => set({ isLoading }),
  
  setError: (error) => set({ error }),
  
  clearError: () => set({ error: null }),
  
  // Get items for a specific day
  getItemsByDay: (day) => {
    const calendar = get().currentCalendar;
    return calendar?.calendar?.[day] || [];
  },
  
  // Get all items flat
  getAllItems: () => {
    const calendar = get().currentCalendar;
    return calendar?.items || [];
  },
  
  // Get summary
  getSummary: () => {
    const calendar = get().currentCalendar;
    return calendar?.summary || null;
  },
}));
